import { useContext } from 'react';
import axios from 'axios';
import { AuthContext } from '../../Context/AuthContext';
import { useQuery } from 'react-query';

const usePendingDeletes = (vesselId) => {
  const { token } = useContext(AuthContext);

  const fetchPendingDeletes = async () => {
    if (!vesselId) {
      throw new Error('Vessel ID is required to fetch pending deletes.');
    }

    try {
      const response = await axios.get(
        `${process.env.REACT_APP_SERVER_URL}/vessel/pendingDeletes/${vesselId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (response.status !== 200) {
        throw new Error('Failed to fetch pending deletes.');
      }

      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.message || 'An error occurred while fetching pending deletes.');
    }
  };

  return useQuery(['pendingDeletes', vesselId], fetchPendingDeletes, {
    enabled: !!vesselId, // Only run query if vesselId is provided
  });
};

export default usePendingDeletes;
